<!-- <template>
  <div class="">
    <div class="row reset-row">
      <div class="col-10 offset-1 col-lg-5 d-flex align-items-center">
        <div class="container-top">
          <div class="row">
            <div class="col-xl-10 offset-xl-1 signup-header text-center text-lg-left">
              Sign in to Churchplus payment
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-xl-10 offset-xl-1">
              <div class="label">Email address</div>
              <div class="mt-2">
                <input type="email" placeholder="Enter your email" v-model="email" class="form-control input-control" />
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-xl-10 offset-xl-1">
              <div class="label">Password</div>
              <div class="mt-2">
                <input type="password" v-model="password" class="form-control input-control" />
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-xl-10 offset-xl-1 d-flex justify-content-between">
              <div class="label">Keep me signed in</div>
              <a href="#">Forgot Password?</a>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-xl-10 offset-xl-1">
              <div class="button w-100" @click="signin">Sign in</div>
              <div class="label mt-4 text-center">
                Not registered yet?
                <router-link :to="{ name: 'SignUpPayment', params: { userId: routeParams } }">Create a new
                  account</router-link>
              </div>
              <div class="label mt-3 text-center hfont cursor-pointer">
                Go back to
                <span class="text-primary" @click="goBack">Give</span>
              </div>
            </div>
          </div>


          <div class="row mt-5">
            <div class="col-md-4">
              <hr />
            </div>
            <div class="col-md-4 signup-option">or sign in with</div>
            <div class="col-md-4">
              <hr />
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-6 col-sm-3">
              <img src="../../assets/google.svg" />
            </div>
            <div class="col-6 col-sm-3 mt-1 text-right">
              <img src="../../assets/facebook.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 offset-lg-2 px-0 d-none d-lg-block bg-wall">
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "@/gateway/backendapi";
import { useRouter, useRoute } from "vue-router";
import finish from "../../services/progressbar/progress"
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const route = useRoute()
    const email = ref("");
    const password = ref("");
    const token = ref("");
    const router = useRouter();
    const routeParams = ref(`${route.params.userId}`)


    const signin = async () => {
      let userdetails = {
        email: email.value,
        password: password.value,
      };

      try {
        let { data } = await axios.post(
          "/mobile/v1/Account/SignIn",
          userdetails
        );
        if (!data.returnObject) {
          ElMessage({
            type: 'warning',
            message: "Incorrect details, " + data.response,
            duration: 5000
          })
        } else if (data && data.returnObject.token && data.status) {
          let giverDetails = {
            giverToken: data.returnObject.token,
            giverId: data.returnObject.userId,
            tenantId: data.returnObject.tenantID
          }
          localStorage.setItem("giverToken", JSON.stringify(giverDetails));
          localStorage.setItem("token", JSON.stringify(data.returnObject.token));

          ElMessage({
            type: 'success',
            message: data.response,
            duration: 5000
          })

          router.push({
            name: "OnlineGiving4",
            params: { userId: route.params.userId },
          });
        }
        finish()
      } catch (error) {
        finish()
        console.log(error);
        if (error.response && error.response.data.message) {
          ElMessage({
            type: 'warning',
            message: error.response.data.message,
            duration: 5000
          })
        } else if (error.response && error.response.toString().includes('network error')) {
          ElMessage({
            type: 'error',
            message: "Please ensure you  have a strong internet connection",
            duration: 5000
          })
        } else {
          ElMessage({
            type: 'error',
            message: "Not successful, please try again",
            duration: 5000
          })
        }
      }

    };

    const goBack = () => {
      router.go(-1)
    }
    return {
      email,
      password,
      signin,
      token,
      routeParams,
      goBack
    };
  },
};
</script>

<style scoped>
.container-top {
  margin-top: 50px;
}

.signup-header {
  font: normal normal 900 52px/71px Nunito Sans;
  letter-spacing: 0px;
  color: #051048;
  opacity: 1;
  margin-top: 25px;
}

.label {
  font: normal normal bold 16px/22px Nunito Sans;
  letter-spacing: 0px;
  color: #020f1e;
}

.input-control {
  background: #eaf4fab2 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 50px;
  border: none;
}

.button {
  background: #1351cd 0% 0% no-repeat padding-box;
  box-shadow: 0px 12px 45px #1351cd61;
  border-radius: 11px;
  opacity: 1;
  text-align: center;
  font: normal normal bold 18px/24px Nunito Sans;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  padding: 12px;
  align-items: center;
  margin: 0;
}

.signup-option {
  font: normal normal bold 18px/24px Nunito Sans;
  letter-spacing: 0px;
  color: #020f1e;
  opacity: 0.6;
  text-align: center;
}

.reset-row {
  margin-right: 0;
}

.bg-wall {
  background-image: url('../../assets/Group257.png');
  height: 100vh;
}
</style> -->

<template>
  <div class="signup-container">
    <div class="container-fluid bg-white h-100">
      <div class="row h-100 no-gutters">
        <!-- Left Side - Form -->
        <div
          class="col-lg-6 d-flex align-items-center justify-content-center mb-5"
        >
          <div class="col-md-9">
            <!-- Logo -->
            <div class="row mb-4 mt-3">
              <div class="col-12">
                <div class="logo-container">
                  <img
                    src="../../assets/churchplusblueLogo.png"
                    alt="ChurchPlus"
                    class="logo"
                  />
                </div>
              </div>
            </div>

            <!-- Form Header -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="signup-title font-weight-600 w-100 s-30">
                  Sign in to ChurchPlus payment
                </div>
              </div>
            </div>
            <!-- Signup Form -->
            <div class="row">
              <div class="col-12 grey-backg border-radius-10 p-5">
                <el-form
                  ref="signinFormRef"
                  :model="signinForm"
                  :rules="formRules"
                  label-position="top"
                  class="signup-form"
                  @submit.prevent="handleSignin"
                >
                  <!-- Email Address -->
                  <div class="form-group mb-3">
                    <label class="form-label">Email Address</label>
                    <el-input
                      v-model="signinForm.email"
                      type="email"
                      placeholder="Enter Your Email"
                      class="custom-input"
                      :prefix-icon="Message"
                    />
                  </div>

                  <!-- Password -->
                  <div class="form-group mb-4">
                    <label class="form-label">Password</label>
                    <el-input
                      v-model="signinForm.password"
                      type="password"
                      placeholder="••••••••••••"
                      class="custom-input"
                      :prefix-icon="Lock"
                      show-password
                    />
                  </div>

                  <!-- Sign Up Button -->
                  <div class="form-group mb-4">
                    <el-button
                      size="large"
                      class="signup-btn w-100"
                      :loading="isLoading"
                      @click="handleSignin"
                    >
                      {{ isLoading ? "Signing in..." : "Sign in" }}
                    </el-button>
                  </div>

                  <!-- Google Sign Up -->
                  <div class="form-group">
                    <el-button
                      size="large"
                      class="google-btn w-100"
                      @click="handleGoogleSignin"
                    >
                      <img
                        src="../../assets/small-google.png"
                        alt="Google"
                        class="google-icon me-2"
                      />
                      Sign on with Google
                    </el-button>
                  </div>

                  <!-- Sign In Link -->
                  <div class="form-group text-center">
                    <span
                      class="signin-text d-flex align-items-center justify-content-center text-dak fw-500"
                    >
                      <span> New here?</span>
                      <router-link
                        class="text-decoration-none text-dak"
                        :to="{
                          name: 'SignUpPayment',
                          params: { userId: routeParams },
                        }"
                        ><u>sign up</u></router-link
                      >
                    </span>
                  </div>

                  <!-- Go Back Link -->
                  <div class="form-group text-center mt-3">
                    <span class="goback-text text-dak s-14 fw-500">
                      Go back to
                      <span class="goback-lin cursor-pointer" @click="goBack"
                        ><u>Give</u></span
                      >
                    </span>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Side - Illustration -->
        <div class="col-lg-6 d-none d-lg-block bg-wall"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElNotification } from "element-plus";
import { Lock, Message } from "@element-plus/icons-vue";
import axios from "@/gateway/backendapi";
import finish from "@/services/progressbar/progress";

// Router setup
const router = useRouter();
const route = useRoute();

// Form reference
const signinFormRef = ref();

// Reactive data
const isLoading = ref(false);
const tenantId = ref("");
const routeParams = ref(`${route.params.userId}`);

const signinForm = reactive({
  email: "",
  password: "",
});

// Form validation rules
const formRules = reactive({
  email: [
    { required: true, message: "Please enter your email", trigger: "blur" },
    {
      type: "email",
      message: "Please enter a valid email address",
      trigger: "blur",
    },
  ],
  password: [
    { required: true, message: "Please enter your password", trigger: "blur" },
    {
      min: 6,
      message: "Password should be at least 6 characters",
      trigger: "blur",
    },
  ],
});

// Methods
const getTenantId = async () => {
  try {
    const response = await axios.get(
      `/give?paymentFormID=${route.params.userId}`
    );
    tenantId.value = response.data.tenantID;
    console.log("Tenant ID retrieved:", tenantId.value);
  } catch (error) {
    console.error("Error getting tenant ID:", error);
    ElNotification({
      title: "Error",
      message: "Failed to load payment form details",
      type: "error",
      duration: 3000,
    });
    finish();
  }
};

const handleSignin = async () => {
  if (!signinFormRef.value) return;

  try {
    const valid = await signinFormRef.value.validate();
    if (!valid) return;

    isLoading.value = true;

    const signupDetails = {
      tenantId: tenantId.value,
      email: signinForm.email,
      password: signinForm.password,
    };

    const { data } = await axios.post(
      "/mobile/v1/Account/SignIn",
      signupDetails
    );

    if (!data.status) {
      ElNotification({
        title: "Sigin Failed",
        message: data.response || "Something went wrong during signin",
        type: "warning",
        duration: 4000,
      });
    } else if (data && data.returnObject.token && data.status) {
      ElNotification({
        title: "Success!",
        message: data.response || "User Sign in successfully",
        type: "success",
        duration: 3000,
      });

      const giverDetails = {
        giverToken: data.returnObject.token,
        giverId: data.returnObject.userId,
        email: data.returnObject.email,
        name: data.returnObject.fullname,
        phone: data.returnObject.phoneNumber,
        tenantId: data.returnObject.tenantID,
        setSignInStatus: true,
      };
      localStorage.setItem("userParamsId", route.params.userId);
      localStorage.setItem("giverToken", JSON.stringify(giverDetails));
      localStorage.setItem("token", JSON.stringify(data.returnObject.token));

      // router.push(`/onlinedonorinfo/${data.returnObject.personID}`);
      router.push({
        name: "NewGivingForm",
        params: { userId: route.params.userId },
      });
      // router.push({
      //   name: "OnlineGiving4",
      //   params: { userId: route.params.userId },
      // });
    }
  } catch (error) {
    if (error.response) {
      ElNotification({
        title: "Sigin Error",
        message: error.response.data || "Failed to create account",
        type: "error",
        duration: 4000,
      });
    } else if (error.message.toLowerCase().includes("network")) {
      ElNotification({
        title: "Network Error",
        message: "Please ensure you have a strong internet connection",
        type: "error",
        duration: 4000,
      });
    } else if (error.message.toLowerCase().includes("timeout")) {
      ElNotification({
        title: "Request Timeout",
        message: "Request took too long to respond. Please refresh the page",
        type: "error",
        duration: 4000,
      });
    } else {
      ElNotification({
        title: "Error",
        message: "An unexpected error occurred. Please try again",
        type: "error",
        duration: 4000,
      });
    }
  } finally {
    isLoading.value = false;
    finish();
  }
};

const handleGoogleSignin = () => {
  ElNotification({
    title: "Coming Soon",
    message: "Google signup will be available soon",
    type: "info",
    duration: 3000,
  });
};

const goBack = () => {
  // router.go(-1);
  router.push(`/give/${route.params.userId}`)
};

// Lifecycle
onMounted(() => {
  getTenantId();
});
</script>

<style scoped>
.grey-backg {
  box-shadow: 0px 4px 10px 0px #0000001a;
}
.bg-wall {
  background-image: url("../../assets/card-image.png");
  background-size: 100%;
  background-position: center;
  /* height: 100%; */
  background-repeat: no-repeat;
}
.signup-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.signup-form-container {
  max-width: 550px;
  width: 100%;
  padding: 2rem;
}

.logo-container {
  margin-bottom: 1rem;
}

.logo {
  height: 40px;
  width: auto;
}

.signup-title {
  background: linear-gradient(270deg, #0e59e4 0%, #043591 55.29%);
  background-clip: text;
  color: transparent;
}

.form-label {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 0.5rem;
  display: block;
}

.custom-input {
  margin-bottom: 0;
}

:deep(.el-input__wrapper) {
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: none;
  transition: all 0.2s ease;
}

:deep(.el-input__wrapper:hover) {
  border-color: #cbd5e0;
}

:deep(.el-input__wrapper.is-focus) {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

:deep(.el-input__inner) {
  color: #2d3748;
  font-size: 0.875rem;
}

:deep(.el-input__inner::placeholder) {
  color: #a0aec0;
}

.signup-btn {
  background: #0b55d4 !important;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  border: none;
  border-radius: 60px;
  padding: 14px 24px;
  font-size: 1rem;
  font-weight: 600;
  height: auto;
  color: #ffffff !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.signup-btn:hover {
  background: #0b55d4 !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
  color: #ffffff !important;
}

.google-btn {
  background: #475467;
  border: 2px solid #e2e8f0;
  border-radius: 60px;
  padding: 14px 24px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #ffffff;
  height: auto;
  transition: all 0.2s ease;
}

.google-btn:hover {
  border-color: #cbd5e0;
  background: #3e4857;
}

.google-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.signin-text {
  font-size: 14px;
  color: #000000;
}

.signin-link {
  color: #000000;
  text-decoration: none;
  text-decoration: underline;
  font-weight: 500;
}

.signin-link:hover {
  color: #2c5282;
  text-decoration: underline;
}

.goback-text {
  font-size: 0.875rem;
  color: #718096;
}

.goback-link {
  color: #3182ce;
  cursor: pointer;
  font-weight: 600;
}

.goback-link:hover {
  color: #2c5282;
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 991.98px) {
  .signup-form-container {
    padding: 1.5rem;
  }

  .signup-title {
    font-size: 1.75rem;
  }
}

@media (max-width: 575.98px) {
  .signup-form-container {
    padding: 1rem;
  }

  .signup-title {
    font-size: 1.5rem;
  }
}

/* Bootstrap utilities */
.w-100 {
  width: 100% !important;
}

.text-center {
  text-align: center !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.h-100 {
  height: 100% !important;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
</style>
